"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTableContext = exports.TableContext = void 0;
var _react = require("react");
var TableContext = /*#__PURE__*/(0, _react.createContext)({});
exports.TableContext = TableContext;
var useTableContext = function useTableContext() {
  var context = (0, _react.useContext)(TableContext);
  if (Object.entries(context).length === 0) {
    throw new Error("The component must be used within a <Table> component");
  }
  return context;
};
exports.useTableContext = useTableContext;